import type { ResolvedWidgetMountOptions, WidgetMountOptions, WidgetRuntimeConfig } from '../types/config';

function resolveContainer(container: string | HTMLElement): HTMLElement {
  if (typeof container === 'string') {
    const element = document.querySelector<HTMLElement>(container);

    if (!element) {
      throw new Error(`Widget container not found: ${container}`);
    }

    return element;
  }

  return container;
}

export function resolveMountOptions(options: WidgetMountOptions): ResolvedWidgetMountOptions {
  return {
    ...options,
    container: resolveContainer(options.container),
    locale: options.locale ?? 'ru',
    theme: options.theme ?? 'auto'
  };
}

export function resolveRuntimeConfig(): WidgetRuntimeConfig {
  const globalBase =
    typeof window !== 'undefined'
      ? (window as typeof window & { __CRYPTO_PAY_WIDGET_API_BASE__?: string }).__CRYPTO_PAY_WIDGET_API_BASE__
      : undefined;

  return {
    apiBaseUrl:
      globalBase ||
      (typeof import.meta !== 'undefined' &&
      typeof import.meta.env !== 'undefined' &&
      typeof import.meta.env.VITE_WIDGET_API_BASE === 'string'
        ? import.meta.env.VITE_WIDGET_API_BASE
        : 'https://api.aviaxy.com'),
    pollIntervalMs: 5000
  };
}